import { Measure } from '@cbsi-cbscom/measure';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagOnceSettingsProperties } from 'tag/ts/tag/model/enums/TagOnceSettingsProperties';
export class AviaAPITransformer extends AbstractTagClass {
    #aviaPlayerWrapper;
    #aviaEventTransformer;
    #playerEventsActive = false;
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaAPITransformer'
        });
        this.#aviaPlayerWrapper = argument?.aviaPlayerWrapper;
        this.#aviaEventTransformer = argument?.aviaEventTransformer;
    }
    #getMerged = (sourceObject) => {
        if (!this.utils.Type.isEmpty(sourceObject) && this.utils.Type.isObject(sourceObject)) {
            return this.utils.DeepMerge.deepmerge({}, sourceObject);
        }
        else {
            return undefined;
        }
    };
    get adaptedPlayer() {
        return this.#aviaPlayerWrapper?.adaptedPlayerInstance;
    }
    get id() {
        return this?.adaptedPlayer?.id;
    }
    addPlayerEventListener = () => {
        return new Promise((resolve, reject) => {
            if (!this.utils.Type.isEmpty(this?.adaptedPlayer)) {
                this.removePlayerEventListener().then(() => {
                    if (this.utils.Type.isObject(window?.avia?.PlayerEvent)) {
                        this?.logger?.log('addPlayerEventListener:', 'subscribe to avia events...');
                        Object.keys(window.avia.PlayerEvent).forEach((key) => {
                            switch (window.avia.PlayerEvent[key]) {
                                default:
                                    this.adaptedPlayer.on(window.avia.PlayerEvent[key], this.#aviaEventTransformer.onPlayerEvent);
                            }
                        });
                    }
                    this.#playerEventsActive = true;
                    resolve({ msg: 'Avia player event listener setup done.' });
                });
            }
            else {
                reject({ msg: 'Avia player instance is undefined' });
            }
        });
    };
    removePlayerEventListener = () => {
        return new Promise((resolve) => {
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.off)) {
                if (this.utils.Type.isObject(window?.avia?.PlayerEvent)) {
                    this?.logger?.log('removePlayerEventListener:', 'unsubscribe from avia events...');
                    Object.keys(window.avia.PlayerEvent).forEach((key) => {
                        this.adaptedPlayer.off(window.avia.PlayerEvent[key], this.#aviaEventTransformer.onPlayerEvent);
                    });
                }
            }
            else {
                this?.logger?.log('removePlayerEventListener:', 'avia player does not exist');
            }
            this.#playerEventsActive = false;
            this.utils.Delay.delay().then(() => {
                resolve({ msg: 'Unsubscribed from avia player events.' });
            });
        });
    };
    loadResource = (resource) => {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.attachResource)) {
                this?.logger?.log('loadResource:', '\nresource.location.mediaUrl:', resource?.location?.mediaUrl, '\nresource.ad.ssai:', resource?.ad?.ssai);
                Measure.end(Metrics.loadToAttachResourceTime);
                Measure.start(Metrics.attachToVideoStartTime);
                this.utils.Delay.delay(this?.tag?.model?.onceSettingsManager?.getOnceSettings(TagOnceSettingsProperties.DELAY_ATTACH_RESOURCE_MS)).then(() => {
                    this.adaptedPlayer.attachResource(resource).then((resource) => {
                        this?.logger?.log('loadResource:', '\navia attachResource success:', resource);
                        resolve({ msg: 'Resource attached', resource: resource });
                    }).catch((error) => {
                        this?.logger?.warn('loadResource:', '\navia attachResource ERROR:', error);
                        reject({ msg: 'attachResource failure:', result: error });
                    });
                });
            }
            else {
                this?.logger?.warn('loadResource:', 'Player does not exist');
                reject({ msg: 'Player does not exist' });
            }
        });
    };
    play = () => {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.play)) {
                this.adaptedPlayer.play().then(() => {
                    resolve({ msg: 'Play operation done' });
                });
            }
            else {
                reject({ msg: 'Play operation error' });
            }
        });
    };
    pause = () => {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.pause)) {
                this.adaptedPlayer.pause().then(() => {
                    resolve({ msg: 'Pause operation done' });
                });
            }
            else {
                reject({ msg: 'Pause operation error' });
            }
        });
    };
    stop = () => {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isEmpty(this?.adaptedPlayer) === false) {
                this.adaptedPlayer.stop().then(() => {
                    this?.logger?.log('player.stop() success');
                    resolve({ msg: 'Stop operation done' });
                }).catch((error) => {
                    this?.logger?.warn('player.stop() failure:', error);
                    reject({ msg: 'Stop operation error', result: error });
                });
            }
            else {
                this?.logger?.warn('player.stop() failure:', 'player.stop does not exist');
                reject({ msg: 'Stop operation error' });
            }
        });
    };
    seek = (time) => {
        return new Promise((resolve, reject) => {
            if (!this.utils.Type.isNumber(time)) {
                reject({ msg: 'Seek operation. Invalid seek time' });
            }
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.seek)) {
                this?.logger?.log('seek', 'time:', time);
                this.adaptedPlayer.seek(time).then(() => {
                    resolve({ msg: 'Seek operation done' });
                });
            }
            else {
                reject({ msg: 'Seek operation error' });
            }
        });
    };
    goLive = () => {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.goLive)) {
                this?.logger?.log('goLive');
                this.adaptedPlayer.goLive();
                resolve({ msg: 'goLive operation done' });
            }
            else {
                reject({ msg: 'goLive method does not exist on player instance' });
            }
        });
    };
    getThumbnails = (time) => {
        return new Promise((resolve, reject) => {
            this?.adaptedPlayer?.getThumbnails(time).then((data) => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    };
    skipAd = () => {
        return new Promise((resolve, reject) => {
            if (this.utils.Type.isFunction(this?.adaptedPlayer?.skipAd)) {
                this?.logger?.log('skipAd');
                try {
                    this.adaptedPlayer.skipAd();
                    this.utils.Delay.delay().then(() => {
                        resolve({ msg: 'skipAd operation done' });
                    });
                }
                catch (error) {
                    this?.logger?.warn('skipAd ERROR:', error);
                    reject({ msg: 'skipAd ERROR:', error });
                }
            }
            else {
                reject({ msg: 'skipAd method does not exist on player instance' });
            }
        });
    };
    get isReady() {
        return true;
    }
    get resource() {
        return this.#getMerged(this?.adaptedPlayer?.resource);
    }
    get isPlayingLive() {
        return this?.adaptedPlayer?.isPlayingLive;
    }
    get streamType() {
        return this?.adaptedPlayer?.streamType;
    }
    get qualities() {
        return this.#getMerged(this?.adaptedPlayer?.qualities);
    }
    get quality() {
        return this.#getMerged(this?.adaptedPlayer?.quality);
    }
    get videoQuality() {
        return this?.adaptedPlayer?.qualityCategory;
    }
    set videoQuality(videoQuality) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.qualityCategory = videoQuality;
    }
    get autoQualitySwitching() {
        return this?.adaptedPlayer?.autoQualitySwitching;
    }
    set autoQualitySwitching(auto) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.autoQualitySwitching = auto;
    }
    get minBitrate() {
        return this?.adaptedPlayer?.minBitrate;
    }
    set minBitrate(bitrate) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.minBitrate = bitrate;
    }
    get maxBitrate() {
        return this?.adaptedPlayer?.maxBitrate;
    }
    set maxBitrate(bitrate) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.maxBitrate = bitrate;
    }
    get audioTracks() {
        return this.#getMerged(this?.adaptedPlayer?.audioTracks);
    }
    get audioTrack() {
        return this.#getMerged(this?.adaptedPlayer?.audioTrack);
    }
    set audioTrack(track) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.audioTrack = track;
    }
    get textTracks() {
        return this.#getMerged(this?.adaptedPlayer?.textTracks);
    }
    get textTrack() {
        return this.#getMerged(this?.adaptedPlayer?.textTrack);
    }
    set textTrack(track) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.textTrack = track;
    }
    get textTrackEnabled() {
        return this.adaptedPlayer.textTrackEnabled;
    }
    set textTrackEnabled(enabled) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.textTrackEnabled = enabled;
    }
    get contentTime() {
        return this?.adaptedPlayer?.contentTime;
    }
    get contentDuration() {
        return this?.adaptedPlayer?.contentDuration;
    }
    get streamTime() {
        return this?.adaptedPlayer?.streamTime;
    }
    get streamDuration() {
        return this?.adaptedPlayer?.streamDuration;
    }
    get liveStreamUtcTime() {
        return this?.adaptedPlayer?.liveStreamUtcTime;
    }
    get liveStreamUtcDuration() {
        return this?.adaptedPlayer?.liveStreamUtcDuration;
    }
    get liveStreamUtcStart() {
        return this?.adaptedPlayer?.liveStreamUtcStart;
    }
    get playbackTime() {
        return this?.adaptedPlayer?.playbackTime;
    }
    get playbackState() {
        return this?.adaptedPlayer?.playbackState;
    }
    get volume() {
        return this?.adaptedPlayer?.volume;
    }
    set volume(value) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.volume = value;
    }
    get muted() {
        return this?.adaptedPlayer?.muted;
    }
    set muted(value) {
        if (!this.utils.Type.isEmpty(this.adaptedPlayer))
            this.adaptedPlayer.muted = value;
    }
    get isAd() {
        return this?.adaptedPlayer?.isAd;
    }
    get adBreakTimes() {
        return this.#getMerged(this?.adaptedPlayer?.getAdBreakTimes());
    }
    get getConfigAsJson() {
        return this.adaptedPlayer.getConfigAsJson;
    }
    get registerHook() {
        return this.adaptedPlayer.registerHook;
    }
    get removeHook() {
        return this.adaptedPlayer.removeHook;
    }
}
